import { items, WFItems } from "@/common/navigation";
export default {
    data() {
        return {
            navScrolled: false,
            showWFMenu: false,
            items,
            WFItems,
            WFLink: "https://wordfinder.yourdictionary.com/"
        };
    },
    methods: {
        closeMenu() {
            this.showWFMenu = false;
            this.$emit("mobile-menu-toggle", false);
        },
        onWFMenuItemClick() {
            this.showWFMenu = !this.showWFMenu;
        },
        onNavScroll(e) {
            this.navScrolled = e.target.scrollTop > 0;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNav.js